
import ConfiguratorHeadlightType from '@/components/ConfiguratorHeadlightType.vue'
import ConfiguratorHeadlightBlock from '@/components/ConfiguratorHeadlightBlock.vue'

export default {
  name: 'Configurator',
  components: { ConfiguratorHeadlightType, ConfiguratorHeadlightBlock },
  props: {
    vehicle: Object,
    altBlocksOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      is_interior: true,
      is_exterior: true,
      products: {
        renovation: [],
        vehicles_alt_products: [],
        headlights_motorcycles: [],
        headlights_trucks: [],
        headlights_tractors: [],
      },
      showProductList: {
        vehicles_alt_products: false,
        renovation: false,
        headlights_motorcycles: false,
        headlights_trucks: false,
        headlights_tractors: false,
      },
      isLoading: {
        vehicles_alt_products: false,
        renovation: false,
        headlights_motorcycles: false,
        headlights_trucks: false,
        headlights_tractors: false,
      },
      reviews_counts: {
        vehicles_alt_products: 0,
        renovation: 0,
        headlights_motorcycles: 0,
        headlights_trucks: 0,
        headlights_tractors: 0,
      },
    }
  },
  watch: {
    is_exterior() {
      this.$trackVehicleEvent(this.vehicle.id, 'toggle_light_zone', { metadata: { zone: 'exterior' } })
    },
    is_interior() {
      this.$trackVehicleEvent(this.vehicle.id, 'toggle_light_zone', { metadata: { zone: 'interior' } })
    },
  },
  computed: {
    filteredHeadlightTypesExterior() {
      return this.filteredHeadlightTypes(false)
    },
    filteredHeadlightTypesInterior() {
      return this.filteredHeadlightTypes(true)
    },
  },
  methods: {
    isLowBeamType(headlightType) {
      if (!headlightType || !headlightType.name) return false
      const name = headlightType.name.toLowerCase()
      // Match "feux de croisement" (FR), "low beam" (EN), "Abblendlicht" (DE), etc.
      return (
        name.includes('croisement') ||
        name.includes('low beam') ||
        name.includes('abblendlicht') ||
        name.includes('anabbaglianti') ||
        name.includes('luces de cruce') ||
        name.includes('dimlicht') ||
        name.includes('luz de cruzamento') ||
        name.includes('ロービーム')
      )
    },
    isFirstLowBeam(headlightType, index) {
      // Only open the first low beam type by default
      if (!this.isLowBeamType(headlightType)) return false
      // Check if any previous item was already a low beam
      const previousLowBeam = this.filteredHeadlightTypesExterior
        .slice(0, index)
        .some(ht => this.isLowBeamType(ht))
      return !previousLowBeam
    },
    filteredHeadlightTypes(isInterior) {
      if (this.vehicle && this.vehicle.headlight_vehicles) {
        const headlightTypes = this.vehicle.headlight_vehicles.map(
          hv => hv.headlight_type
        )
        const uniqueHeadlightTypes = Array.from(
          new Set(headlightTypes.map(ht => ht.id))
        ).map(id => headlightTypes.find(ht => ht.id === id))

        return uniqueHeadlightTypes
          .filter(item => item.is_interior === isInterior)
          .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
      }
      return []
    },
    toggleProductList(productsToLoad) {
      if (this.showProductList[productsToLoad]) {
        this.showProductList[productsToLoad] = false
      } else {
        if (this.reviews_counts[productsToLoad] > 0) {
          this.showProductList[productsToLoad] = true
          return
        }
        this.isLoading[productsToLoad] = true
        this.$productService
          .fetchConfiguratorGroupProducts(productsToLoad)
          .then(({ data }) => {
            this.products[productsToLoad] = data

            this.isLoading[productsToLoad] = false
            this.showProductList[productsToLoad] = true
            this.reviews_counts[productsToLoad] = this.products[
              productsToLoad
            ].reduce((acc, product) => {
              return acc + product.published_reviews
            }, 0)
          })
      }
    },
  },
}
